var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _g4, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressureCleaning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.634 37.2702H38.428C38.5226 37.2702 38.5876 37.2407 38.6526 37.1697C38.7177 37.0988 38.7413 37.0278 38.7295 36.9332L36.4179 16.1992L36.0455 12.8647C36.0337 12.711 35.9036 12.5928 35.744 12.5928H22.318C22.1584 12.5928 22.0283 12.711 22.0106 12.8647L19.9887 31.0092C19.9887 31.0269 19.9887 31.0447 19.9828 31.0624V31.0683L19.3325 36.9332C19.3207 37.0278 19.3443 37.0988 19.4094 37.1697C19.4744 37.2407 19.5394 37.2702 19.634 37.2702ZM32.5575 34.864H25.5341C25.1557 34.864 24.8542 34.5624 24.8542 34.1841C24.8542 33.8116 25.1557 33.5042 25.5341 33.5042H32.5575C32.9299 33.5042 33.2314 33.8116 33.2314 34.1841C33.2314 34.5624 32.9299 34.864 32.5575 34.864ZM32.5575 32.3276H25.5341C25.1557 32.3276 24.8542 32.0202 24.8542 31.6477C24.8542 31.2693 25.1557 30.9678 25.5341 30.9678H32.5575C32.9299 30.9678 33.2314 31.2693 33.2314 31.6477C33.2314 32.0202 32.9299 32.3276 32.5575 32.3276ZM29.028 15.7262C32.1673 15.7262 34.7212 18.2744 34.7212 21.4137C34.7212 24.5531 32.1673 27.1013 29.028 27.1013C25.8947 27.1013 23.3408 24.5531 23.3408 21.4137C23.3408 18.2744 25.8947 15.7262 29.028 15.7262Z",
    fill: "#1DC7F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_19055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1602 0.833252H41.7363V17.4819H24.1602V0.833252Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_19055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2616 3.62375C32.6483 3.49368 36.7925 3.37544 38.9444 7.49623C39.8431 9.21667 39.7485 11.0849 38.6666 13.0537C38.3296 13.6626 37.9512 14.1888 37.6084 14.6027L37.8094 16.4C38.2409 15.9743 39.1218 15.0283 39.8312 13.7454C41.1496 11.3746 41.2619 8.99792 40.1505 6.86953C37.6024 1.99199 32.6187 2.13388 28.2262 2.26395C27.4458 2.2876 26.7009 2.30533 25.9737 2.30533L25.5244 3.65922C26.423 3.67696 27.3571 3.6474 28.2616 3.62375Z",
    fill: "#203B72"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0302 25.7476C31.4186 25.7476 33.3636 23.8025 33.3636 21.4139C33.3636 19.0254 31.4186 17.0803 29.0302 17.0803C26.6417 17.0803 24.7026 19.0254 24.7026 21.4139C24.7026 23.8025 26.6417 25.7476 29.0302 25.7476ZM29.0302 20.0778C29.1366 20.0778 29.2371 20.0896 29.3317 20.1133L30.4963 18.8894C30.7564 18.6234 31.1821 18.6116 31.454 18.8717C31.726 19.1259 31.7378 19.5575 31.4777 19.8295L30.3189 21.0474C30.3485 21.1656 30.3662 21.2839 30.3662 21.4139C30.3662 22.153 29.7691 22.7501 29.0302 22.7501C28.2971 22.7501 27.6941 22.153 27.6941 21.4139C27.6941 20.6749 28.2971 20.0778 29.0302 20.0778Z",
    fill: "#1DC7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1304 5.33893L18.9667 4.72998L18.541 6.00701L20.6752 6.71647L21.1304 5.33893Z",
    fill: "#1DC7F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48074 37.069C9.1142 37.0039 8.75949 37.2463 8.70037 37.6188C8.58805 38.2396 8.24515 38.4997 8.17421 38.4879C8.10327 38.4701 7.86679 38.1095 7.97321 37.4887L8.79496 32.824C8.85999 32.4515 8.61169 32.1027 8.24515 32.0377C7.87862 31.9727 7.5239 32.221 7.45887 32.5875L6.63712 37.2582C6.41838 38.5293 6.98592 39.6585 7.93773 39.824C8.01459 39.8418 8.09736 39.8477 8.17421 39.8477C9.03735 39.8477 9.82954 39.02 10.0365 37.8494C10.1015 37.4828 9.85319 37.134 9.48074 37.069Z",
    fill: "#1DC7F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_19055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0522 0H25.6733V11.4282H12.0522V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_19055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7101 3.24579L22.1626 4.21538L22.2158 4.23312L23.7588 4.66471L24.3914 2.7669C24.3973 2.75507 24.3973 2.73734 24.4091 2.72551L24.6515 1.98058L15.3876 0L12.3784 9.04563L15.4171 10.0566L15.7364 10.163L17.8824 3.68329C18.0006 3.34038 18.3613 3.15119 18.7101 3.24579Z",
    fill: "#1DC7F9"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3929 38.0743C18.0737 37.7136 17.9318 37.2702 17.985 36.7854L18.5644 31.5354C17.7485 31.5709 17.0923 32.2449 17.0923 33.0726V39.1089C17.0923 39.9543 17.784 40.6402 18.6294 40.6402C19.4748 40.6402 20.1665 39.9543 20.1665 39.1089V38.63H19.6344C19.1555 38.63 18.7121 38.429 18.3929 38.0743Z",
    fill: "#203B72"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_19055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 31,
    width: 5,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7812 31.104H41.7363V41.6986H37.7812V31.104Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_19055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5243 31.5354C39.5184 31.5354 39.5066 31.5354 39.4948 31.5354L40.0801 36.7854C40.1333 37.2702 39.9914 37.7136 39.6662 38.0743C39.3529 38.429 38.9095 38.63 38.4306 38.63H37.9932V39.1089C37.9932 39.9543 38.6789 40.6402 39.5243 40.6402C40.3757 40.6402 41.0614 39.9543 41.0614 39.1089V33.0726C41.0614 32.2271 40.3757 31.5354 39.5243 31.5354Z",
    fill: "#203B72"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78564 25.8185L12.8285 10.6301L14.336 11.1267L9.29318 26.3211L7.78564 25.8185Z",
    fill: "#203B72"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43543 28.4554C9.54185 28.1302 9.36449 27.7755 9.03934 27.6691L7.183 27.0483C7.02338 27.001 6.85784 27.0128 6.71004 27.0897C6.55633 27.1606 6.44992 27.2907 6.39671 27.4444L5.87646 29.0052L8.91518 30.0162L9.43543 28.4554Z",
    fill: "#203B72"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7901 7.86304H26.2743L25.2397 11.2389H32.8247L31.7901 7.86304Z",
    fill: "#203B72"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_19055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 34,
    width: 7,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4541 34.1309H7.50789V42H1.4541V34.1309Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_19055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85135 34.2016C5.49664 34.0834 5.11236 34.2726 4.99413 34.6332L2.84219 41.1071C2.72395 41.4618 2.91905 41.8461 3.27376 41.9643C3.3447 41.988 3.41565 41.9998 3.48659 41.9998C3.77036 41.9998 4.0364 41.8224 4.13099 41.5327L6.28292 35.0589C6.40116 34.7042 6.21198 34.3199 5.85135 34.2016Z",
    fill: "#1DC7F9"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40747 36.1825L5.54167 31.9494C5.7072 31.6183 5.57714 31.2103 5.24016 31.0389C4.90318 30.8734 4.49526 31.0034 4.32972 31.3404L2.19553 35.5735C1.90584 36.1352 1.49792 36.283 1.4388 36.2534C1.36195 36.2002 1.27327 35.7686 1.5393 35.2425C1.70484 34.9055 1.57478 34.4975 1.2378 34.332C0.900817 34.1605 0.492897 34.2965 0.327363 34.6335C-0.257914 35.7805 -0.0391751 37.0279 0.829876 37.4654C1.02497 37.5659 1.23188 37.6132 1.45063 37.6132C2.17779 37.6132 2.95225 37.0752 3.40747 36.1825Z",
    fill: "#1DC7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureCleaning);
export default __webpack_public_path__ + "static/media/Pressure Cleaning.6f4bee11ee11990f0cd52e7e9bfc8fc9.svg";
export { ForwardRef as ReactComponent };